export const fbp = '_fbp';
export const fbc = '_fbc';

export const fbcFromClId = 'fbc_from_clid';

/**
 * The user's facebook user login info
 * @fb_login_email when user login with facebook,the `response.email` will be storage as `fb_login_email`
 * @fb_login_id when user login with facebook,the `response.userID` will be storage as `fb_login_id`
 */
export const fbUserLoginInfo = 'fb_user_login_info';
